import DistributorsPage from './DistributorsPage';

export default DistributorsPage;
